const isSessionInvalidError = (error: any) => {
  return error?.code === 401 && error?.message === 'Session invalid'
}

export { isSessionInvalidError }
